import React from 'react';
import styles from './BannerStoreMobile.module.css';
import bannerStoreImg from '../assets/images/banner-store-img.png';
import { IconContext } from 'react-icons';
import { IoIosClose } from "react-icons/io";
// import { BsStarHalf, BsStarFill, BsStar } from "react-icons/bs";
import useLocalStorage from '../hooks/useLocalStorage';
import { useIntl } from 'react-intl';

export const BannerStoreMobile = ({ storeLink }) => {

  const [bannerDisplay, setBannerDisplay] = useLocalStorage('mobileLinksBannerVisibility', true);
  const intl = useIntl();

  // const renderNumberStars = () => {

  //   const numberStars = 4.5;

  //   return (
  //     ["1", "2", "3", "4", "5"].map(el => (
  //       <IconContext.Provider
  //         key={el}
  //         value={{
  //           color: "#ff9900",
  //           className: "global-class-name"
  //         }}
  //       >
  //         <span style={{ fontSize: '100%', marginRight: "1%" }}>
  //           {
  //             numberStars - el >= 0 ? <BsStarFill /> :
  //               numberStars - el == -0.5 ? <BsStarHalf /> :
  //                 <BsStar />
  //           }
  //         </span>
  //       </IconContext.Provider>
  //     )));
  // };

  return (
    <>
      {
        bannerDisplay && storeLink ?
          (
            <div className={styles.bannerContainer}>
              <div className="row align-items-start">
                <IconContext.Provider
                  value={{
                    color: "gray",
                    className: "global-class-name"
                  }}
                >
                  <div style={{ fontSize: '250%', marginLeft: "1%", marginTop: "2%" }}>
                    <IoIosClose style={{ cursor: "pointer" }} onClick={() => setBannerDisplay(false)} />
                  </div>
                </IconContext.Provider>
                <div className={styles.imgContainer}>
                  <img src={bannerStoreImg} style={{ height: "100%", width: "100%" }} />
                  <span style={{ position: 'relative', left: '25%'}}>
                    <h1 style={{ fontSize: '100%', color: "#666666", fontWeight: "600", marginBottom: "0" }}>{"DEA"}</h1>
                  </span>
                </div>
                <div className={styles.infoStoreContainer}>
                  <div>
                    <b style={{ fontSize: '120%', fontWeight: "600" }}>
                      {intl.formatMessage({ id: 'bannerStoreMobile.psCampusBiomedico' })}
                    </b>
                  </div>
                  <div>
                    {/* <br />
                    <br /> */}
                    {/* {renderNumberStars()} */}
                  </div>
                  <div>
                    <span style={{ fontSize: '100%', color: "#666666", fontWeight: "600" }}>
                      {intl.formatMessage({ id: 'bannerStoreMobile.scaricaApp' })}
                    </span>
                  </div>
                </div>
                <div style={{ marginLeft: "30%", marginTop: "5%" }}>
                  <span style={{ fontSize: '150%' }}>
                    <a href={storeLink}>
                      {intl.formatMessage({ id: 'bannerStoreMobile.vedi' })}
                    </a>
                  </span>
                </div>
              </div>
            </div>) :
          null
      }
    </>
  );
}